import { render } from "./AccountSettingsView.vue?vue&type=template&id=4ce67daa"
import script from "./AccountSettingsView.vue?vue&type=script&lang=js"
export * from "./AccountSettingsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__